import { AnimatedText, AnimatedTitle } from "@/components/ui/AnimatedText";
import { ChevronDown } from "lucide-react";
import { useSEO } from "@/utils/useSEO";
import { useTranslation } from "react-i18next";

export default function AboutUs() {
  const { t } = useTranslation();
  useSEO(
    "About Us",
    "Discover the story behind Patal Kikian Villas, a luxury boutique retreat nestled in the serene highlands of Sidemen, Bali. Learn about our commitment to authentic Balinese hospitality, sustainable tourism, and creating unforgettable experiences for every guest."
  );
  return (
    <>
      <section className="relative min-h-[100dvh] w-full flex items-center justify-center">
        <div className="absolute inset-0">
          <img src="/media/patal-kikian-hero-banner.webp" alt="About Background" className="w-full h-full object-cover opacity-85" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/30 to-transparent" />
        </div>
        
        <div className="relative z-10 text-center px-4 mt-20">
          <AnimatedText delay={0.2} className="text-gold uppercase tracking-[0.3em] text-sm mb-4 font-semibold">
            {t("about.hero.subtitle")}
          </AnimatedText>
          <AnimatedTitle
            title={t("about.hero.title")}
            className="text-4xl md:text-5xl lg:text-6xl font-luxury text-shadow-lg leading-tight mb-6 max-w-4xl mx-auto"
          />
          <AnimatedText delay={0.3}>
            <p className="text-white/80 max-w-3xl mx-auto text-lg leading-relaxed">
              {t("about.hero.desc")}
            </p>
          </AnimatedText>
          
        </div>
      
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20">
          <button 
            onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
            className="text-white/70 hover:text-white transition-colors duration-300 flex flex-col items-center gap-2 cursor-pointer"
            aria-label="Scroll to content"
          >
            <span className="uppercase tracking-[0.2em] text-[10px]">{t("about.hero.btnScroll")}</span>
            <ChevronDown size={24} className="animate-bounce" />
          </button>
        </div>
      </section>

      <section className="py-24 bg-background">
        <div className="container mx-auto px-6 max-w-3xl">

          <div className="space-y-12 text-white/70 leading-relaxed text-base font-light">
            <AnimatedText delay={0.2} className="space-y-6">
              <p>
                {t("about.story.p1")}
              </p>
              <p>
                {t("about.story.p2")}
              </p>
            </AnimatedText>

            <AnimatedText delay={0.3} className="border-t border-white/5 pt-12 space-y-6">
              <h3 className="text-2xl font-luxury text-gold uppercase tracking-wider">{t("about.story.subtitle")}</h3>
              <p>
                {t("about.story.p3")}
              </p>
            </AnimatedText>

            <AnimatedText delay={0.4} className="border-t border-white/5 pt-12 space-y-6 text-center">
              <p className="text-lg text-white font-luxury italic">
                {t("about.story.quote")}
              </p>
              <p className="text-gold uppercase tracking-[0.2em] text-xs font-semibold pt-4">
                {t("about.story.footer")}
              </p>
            </AnimatedText>
          </div>
        </div>
      </section>
    </>
  );
}
